function parsePositiveInt(raw: string | undefined, fallback: number): number {
  if (raw == null || raw === '') return fallback;
  const n = Number(raw);
  return Number.isFinite(n) && n >= 0 ? Math.trunc(n) : fallback;
}

/** Parsed Vite env for the backoffice SPA — single place to read `import.meta.env`. */
export const backofficeEnv = {
  /** Short id (telemetry, logs) */
  appName: import.meta.env.VITE_APP_NAME || 'backoffice',
  /** Window / document title */
  appDisplayName: import.meta.env.VITE_APP_DISPLAY_NAME || 'EURECA Backoffice',
  /** Base URL of the Backoffice BFF */
  apiUrl: import.meta.env.VITE_API_URL || 'http://localhost:3004',
  /**
   * Default timeout for BFF `fetch` (ms). `0` disables the SDK default timeout.
   * @see packages/backoffice-api-sdk `fetchClient`
   */
  apiRequestTimeoutMs: parsePositiveInt(import.meta.env.VITE_API_REQUEST_TIMEOUT_MS, 30_000),
  keycloak: {
    url: import.meta.env.VITE_KEYCLOAK_URL,
    realm: import.meta.env.VITE_KEYCLOAK_REALM,
    clientId: import.meta.env.VITE_KEYCLOAK_CLIENT_ID,
    onLoad:
      import.meta.env.VITE_KEYCLOAK_ON_LOAD === 'login-required'
        ? ('login-required' as const)
        : ('check-sso' as const),
    silentCheckSsoRedirectUri:
      import.meta.env.VITE_KEYCLOAK_SILENT_CHECK_SSO_REDIRECT_URI || undefined,
  },
} as const;
